import { useState, useEffect } from 'react';
import { getPreferences, setPreferences } from '../api';

/**
 * Le joueur choisit si son équipe est prévenue le jour de son anniversaire.
 * Masqué si sa date de naissance n'est pas connue : il n'y aurait rien à régler.
 */
export default function PartageAnniversaire({ onToast }) {
  const [p, setP] = useState(null);
  useEffect(() => { getPreferences().then(setP).catch(() => {}); }, []);
  if (!p?.joueur || !p.date_connue) return null;

  async function basculer() {
    const val = !p.anniversaire_equipe;
    setP({ ...p, anniversaire_equipe: val });
    try {
      await setPreferences({ anniversaire_equipe: val });
      onToast?.(val ? "L'équipe sera prévenue de ton anniversaire" : "L'équipe ne sera plus prévenue");
    } catch (e) { setP({ ...p }); onToast?.(e.message, 'error'); }
  }

  return (
    <div className="card" style={{ marginBottom:14 }}>
      <label style={{ display:'flex', gap:11, alignItems:'center', cursor:'pointer' }}>
        <span style={{ fontSize:22 }} aria-hidden="true">🎂</span>
        <div style={{ flex:1 }}>
          <div style={{ fontSize:13, fontWeight:700 }}>Prévenir l'équipe de mon anniversaire</div>
          <div style={{ fontSize:11.5, color:'var(--muted)', marginTop:2, lineHeight:1.5 }}>
            Le jour J, tes coéquipiers reçoivent un message. Jamais ton âge.</div>
        </div>
        <input type="checkbox" checked={!!p.anniversaire_equipe} onChange={basculer}
               style={{ width:20, height:20, accentColor:'var(--accent)', flexShrink:0 }} />
      </label>
    </div>
  );
}
